import { render, staticRenderFns } from "./DrugsItem.vue?vue&type=template&id=4ec00fd8&scoped=true"
import script from "./DrugsItem.vue?vue&type=script&lang=js"
export * from "./DrugsItem.vue?vue&type=script&lang=js"
import style0 from "./DrugsItem.vue?vue&type=style&index=0&id=4ec00fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec00fd8",
  null
  
)

export default component.exports